export default __webpack_public_path__ + "static/media/boy.34ece923.png";